<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform" xmlns:v-clipboard="http://www.w3.org/1999/xhtml">
    <div class="row">
        <div class="col-12 mb-4">
            <v-card>
                <v-card-title>
                    <div class="col-12 col-lg-4 col-md-4 p-0">
                        <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
                                      hide-details></v-text-field>
                    </div>
                </v-card-title>
                <v-data-table :headers="headers" :items="means_paiements" :search="search" sort-by="name"
                              class="elevation-1" :loading="means_paiements==undefined"
                              loading-text="Chargement en cours...">
                    <template v-slot:item._file="{item}">
                        <a v-if="item._file" href="javascript:void(0)"
                           @click="showImage('/'+item._file,item._name,'img')">
                            <v-img
                                    :lazy-src="item._file"
                                    max-height="50"
                                    max-width="70"
                                    :src="item._file"
                            ></v-img>
                        </a>
                    </template>
                    <template v-slot:item._taux="{ item }">
                        <v-chip color="primary" dark>{{ item._taux }} %</v-chip>
                    </template>

                    <template v-slot:item._taux_intram="{ item }">
                        <v-chip color="primary" dark>{{ item._taux_intram }} %</v-chip>
                    </template>

                    <template v-slot:item._taux_service="{ item }">
                        <v-chip color="primary" dark>{{ item._taux_service }} %</v-chip>
                    </template>

                    <template v-slot:item._type="{ item }">
                        <v-chip :color="getColor(item._type)" dark>{{ item._type }}</v-chip>
                    </template>

                    <template v-slot:item._prefixes="{ item }">
                        <v-chip v-if="item._type=='Mobile'" @click="showImage(item._prefixes,item._name,'chip')"
                                color="primary" dark> {{$t("liste")}}
                        </v-chip>
                    </template>
                    <template v-slot:item._sandbox_numbers="{ item }">
                        <v-chip @click="showImage(item._sandbox_numbers,item._name,'chip2')"
                                color="primary" dark> {{$t("liste")}}
                        </v-chip>
                    </template>

                    <template v-slot:item._active="{ item }">
                        <v-chip
                                :color="item._active?'green':'red'" dark>
                            {{item._active?$t("means_paiement.actif"):$t("means_paiement.inactif")}}
                        </v-chip>
                    </template>

                    <template v-slot:item._country._name="{ item }">

                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <div v-bind="attrs"
                                     v-on="on">
                                    <country-flag :country=" item._country._code " size='normal'/>
                                </div>
                            </template>
                            <span>{{item._country._name}}</span>
                        </v-tooltip>

                    </template>

                    <template v-slot:item._code="{ item }">
                        <span>{{item._code}}</span>
                    </template>

                    <template v-slot:top>
                        <v-toolbar flat color="white">
                            <v-spacer></v-spacer>

                            <v-dialog v-model="dialogShowImg" max-width="30%">

                                <v-card>
                                    <v-card-title>
                                        <span class="headline"> {{nametheme}} </span>
                                    </v-card-title>

                                    <v-card-text>

                                        <img v-if="type=='img'" :src="link" style="width: 100%; height: 100%" alt="">
                                        <div v-else-if="type=='chip2'" class="row pl-4">
                                            <div class="" v-if="link">


                                                <div class="container">
                                                    {{$t('means_paiement.title_test_numbersucces')}}
                                                    <div class="row" v-if="link.success">
                                                        <v-chip v-for="row in link.success" :key="row"
                                                                style="margin-right: 1%" color="primary" dark>{{ row }}
                                                        </v-chip>
                                                    </div>
                                                    <div class="" v-else>
                                                        {{$t("means_paiement.liste_vide")}}
                                                    </div>
                                                </div>

                                                <div class="container">
                                                    {{$t('means_paiement.title_test_number')}}
                                                    <div class="row" v-if="link.error">
                                                        <v-chip v-for="row in link.error" :key="row"
                                                                style="margin-right: 1%" color="primary" dark>{{ row }}
                                                        </v-chip>
                                                    </div>
                                                    <div class="" v-else>
                                                        {{$t("means_paiement.liste_vide")}}
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="" v-else>
                                                {{$t("means_paiement.liste_vide")}}
                                            </div>

                                        </div>

                                        <div v-else class="row pl-4">
                                            <div class="" v-if="link>0">
                                                <v-chip v-for="row in link" :key="row" style="margin-right: 1%"
                                                        color="primary" dark>{{ row }}
                                                </v-chip>
                                            </div>
                                            <div class="" v-else>
                                                {{$t("means_paiement.liste_vide")}}
                                            </div>
                                        </div>

                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn class="dark" text @click="dialogShowImg = false">{{$t("close")}}</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>

                            <v-dialog v-model="dialog" max-width="800px">
                                <template v-slot:activator="{ on }">
                                    <v-btn style="color: #fff" color="primary" class="mb-2" @click="setdefault"
                                           v-on="on">{{$t('means_paiement.new')}}
                                    </v-btn>
                                </template>

                                <v-card>

                                    <v-card-title>
                                        <v-col md="11" lg="11" sm="11">
                                            <span class="headline">  {{ formTitle }} </span>
                                        </v-col>
                                        <v-col md="1" lg="1" sm="1">
                                            <v-icon style="cursor: pointer" @click="setdefaultClose()"> mdi-close
                                            </v-icon>
                                        </v-col>
                                    </v-card-title>

                                    <v-card-text>

                                        <v-form ref="form" v-model="valid" :lazy-validation="lazy"
                                                enctype="multipart/form-data">
                                            <v-stepper v-model="e1">
                                                <v-stepper-header>
                                                    <v-stepper-step :complete="e1 > 1" step="1">
                                                        {{$t('means_paiement.etape')}} 1
                                                    </v-stepper-step>

                                                    <v-divider></v-divider>

                                                    <v-stepper-step :complete="e1 > 2" step="2">
                                                        {{$t('means_paiement.etape')}} 2
                                                    </v-stepper-step>

                                                    <v-divider></v-divider>

                                                    <v-stepper-step :complete="e1 > 3" step="3">
                                                        {{$t('means_paiement.etape')}} 3
                                                    </v-stepper-step>
                                                    <v-stepper-step step="4">{{$t('means_paiement.etape')}} 4
                                                    </v-stepper-step>
                                                </v-stepper-header>

                                                <v-stepper-items>
                                                    <v-stepper-content step="1">


                                                        <div class="row">
                                                            <div class="col-12 col-md-6 col-lg-6"
                                                                 style="text-align: center">
                                                                <v-card
                                                                        @click="chooseItem('Mobile')"
                                                                        id="Mobile"
                                                                        class="ma-3 pa-6 chooseAll"
                                                                        outlined
                                                                        tile
                                                                        :style="getBackColor('Mobile')+'text-align: center;'"
                                                                >
                                                                    <img src="images/phonemode.svg"
                                                                         width="110" alt=""
                                                                         style="padding: 2.5%">
                                                                    <h3 style="margin-top: 9%; font-weight: bold;"
                                                                        class="text-uppercase">
                                                                        {{$t('means_paiement.moyenmobile')}}</h3>

                                                                </v-card>
                                                            </div>
                                                            <div class="col-12 col-md-6 col-lg-6"
                                                                 style="text-align: center">
                                                                <v-card
                                                                        @click="chooseItem('Banque')"
                                                                        id="Banque"
                                                                        class="ma-3 pa-6 chooseAll"
                                                                        outlined
                                                                        tile
                                                                        :style="getBackColor('Banque')+'text-align: center;'"

                                                                >
                                                                    <img src="images/bankmode2.png"
                                                                         width="120" alt="">

                                                                    <h3 style="margin-top: 5%; font-weight: bold"
                                                                        class="text-uppercase">
                                                                        {{$t('means_paiement.moyenbancaire')}}</h3>

                                                                </v-card>
                                                            </div>
                                                            <div class="container">
                                                                <v-col class="d-flex" cols="12" sm="6" md="12">
                                                                    <v-select
                                                                            @change="validestep(1)"
                                                                            :rules="countryRules"
                                                                            id="countries"
                                                                            v-model="editedItem._country"
                                                                            item-text="_name"
                                                                            item-value="_id"
                                                                            :items="countries"
                                                                            :label="$t('means_paiement.country')"
                                                                            :placeholder="$t('means_paiement.choose')"
                                                                            dense
                                                                            required

                                                                    ></v-select>
                                                                </v-col>

                                                            </div>
                                                        </div>


                                                        <div class="text-right container">
                                                            <v-btn
                                                                    color="primary"
                                                                    @click="e1 = 2"
                                                                    :disabled="!step1"
                                                            >
                                                                {{$t('continuer')}}
                                                            </v-btn>
                                                        </div>


                                                    </v-stepper-content>

                                                    <v-stepper-content step="2">
                                                        <div class="row">

                                                            <v-col cols="12" sm="6" md="12">

                                                                <v-file-input @change="selectedFile"
                                                                              id="input_file"
                                                                              prepend-icon="mdi-camera"
                                                                              v-model="editedItem._file" 
                                                                              ref="file"
                                                                              :rules="(editedIndex === -1) ? codeRules : []"
                                                                              show-size
                                                                              accept="image/*"
                                                                              label="Fichier"></v-file-input>

                                                                <span style="color: #B71C1C" v-if="errors_file!=null">{{errors_file}}</span>

                                                            </v-col>
                                                            <v-col cols="12" sm="6" md="12">
                                                                <v-text-field @keyup="validestep(2)"
                                                                              :rules="nameRules"
                                                                              v-model="editedItem._name"
                                                                              :label="$t('means_paiement.name')"></v-text-field>
                                                                <!--
                                                                                                                                <span style="color: #B71C1C" v-if="errors_name!=null">{{errors_name}}</span>
                                                                -->

                                                            </v-col>

                                                        </div>
                                                        <div class="text-right container">
                                                            <div class="offset-md-7 col-md-5">
                                                                <div class="row">
                                                                    <div class="col-md-6" style="padding: 2px">
                                                                        <v-btn
                                                                                class=" dark"
                                                                                text @click="e1 = 1">{{$t('return')}}
                                                                        </v-btn>

                                                                    </div>
                                                                    <div class="col-md-6" style="padding: 2px">
                                                                        <v-btn
                                                                                color="primary"
                                                                                @click="e1 = 3"
                                                                                :disabled="!step2"
                                                                        >
                                                                            {{$t('continuer')}}
                                                                        </v-btn>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </v-stepper-content>

                                                    <v-stepper-content step="3">
                                                        <div class="row">

                                                            <v-col cols="12" sm="6" md="12">
                                                                <span class="col-12">{{$t('means_paiement.taux_intram')+' : '+editedItem._taux_intram}}</span>
                                                                <v-slider
                                                                        v-model="editedItem._taux_intram"
                                                                        color="black"
                                                                        min="0.1"
                                                                        max="100"
                                                                        step="0.1"
                                                                        thumb-label
                                                                ></v-slider>

                                                            </v-col>


                                                            <v-col cols="12" sm="6" md="12">
                                                                <span class="col-12">{{$t('means_paiement.taux_service')+' : '+editedItem._taux_service}}</span>
                                                                <v-slider
                                                                        v-model="editedItem._taux_service"
                                                                        color="black"
                                                                        min="0.1"
                                                                        max="100"
                                                                        step="0.1"
                                                                        thumb-label
                                                                ></v-slider>
                                                                {{$t('means_paiement.taux')}} :
                                                                {{editedItem._taux_service+editedItem._taux_intram}}
                                                            </v-col>

                                                            <v-col cols="12" sm="6" md="12">
                                                                <v-text-field @keyup="validestep(3)"
                                                                              :rules="fees_reversementRules"
                                                                              v-model="editedItem._fees_reversement"
                                                                              :label="$t('means_paiement.fees_reversement')+' ('+(devisedatas?devisedatas._code_alpha:'---')+')'"></v-text-field>

                                                                <span style="color: #B71C1C" v-if="errors_fees!=null">{{errors_fees}}</span>


                                                            </v-col>

                                                        </div>
                                                        <div class="text-right container">
                                                            <div class="offset-md-7 col-md-5">
                                                                <div class="row">
                                                                    <div class="col-md-6" style="padding: 2px">
                                                                        <v-btn
                                                                                class=" dark"
                                                                                text @click="e1 = 1">{{$t('return')}}
                                                                        </v-btn>

                                                                    </div>
                                                                    <div class="col-md-6" style="padding: 2px">
                                                                        <v-btn
                                                                                color="primary"
                                                                                @click="e1 = 4"
                                                                                :disabled="!step3"
                                                                        >
                                                                            {{$t('continuer')}}
                                                                        </v-btn>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </v-stepper-content>

                                                    <v-stepper-content step="4">
                                                        <v-alert v-if="errors" dense outlined
                                                                 :type="(errors.update_error)?'error':'success'">
                                                            {{$t(errors.operation)}}
                                                        </v-alert>

                                                        <v-text-field v-if="submitting" color="primary" loading
                                                                      disabled></v-text-field>
                                                        <v-row>


                                                            <v-col cols="12" sm="6" md="12"
                                                                   v-if="editedItem._type==='Mobile'">
                                                                <span class="col-12">{{$t('means_paiement.title_prefixe')}}</span>
                                                                <v-row v-for="(item, index) in prefixeval"
                                                                       v-bind:key="item"
                                                                       :id="index+'row'">
                                                                    <v-col cols="12" sm="10" md="10">
                                                                        <v-text-field
                                                                                type="number"
                                                                                @change="validestep(4)"
                                                                                clearable
                                                                                :label="$t('means_paiement.prefixe')"
                                                                                name="prefixe[]"
                                                                                placeholder="ex : 22961 / 22895"
                                                                                :value="item"></v-text-field>
                                                                    </v-col>


                                                                    <v-col v-if="index===0" cols="2" sm="1" md="1">
                                                                        <v-btn @click="add_cqq" class="mx-2" fab dark
                                                                               small color="primary">
                                                                            <v-icon dark>mdi-plus</v-icon>
                                                                        </v-btn>
                                                                    </v-col>
                                                                    <v-col v-else cols="2" sm="1" md="1">
                                                                        <v-btn class="mx-2" @click="remove_cqq(index)"
                                                                               fab dark small
                                                                               color="red">
                                                                            <v-icon dark>mdi-minus</v-icon>
                                                                        </v-btn>
                                                                    </v-col>

                                                                </v-row>
                                                                <span style="color: #B71C1C" v-if="errors_prefix!=null">{{errors_prefix}}</span>

                                                            </v-col>

                                                            <v-col cols="12" sm="6" md="12">
                                                                <span class="col-12">{{$t('means_paiement.title_test_number')}}</span>
                                                                <v-row v-for="(item, index) in test_numberval"
                                                                       v-bind:key="index"
                                                                       :id="index+'row2'">
                                                                    <v-col cols="12" sm="10" md="10">
                                                                        <v-text-field
                                                                                type="number"
                                                                                @change="validestep(4)"
                                                                                clearable
                                                                                :label="$t('means_paiement.test_number')"
                                                                                name="test_number[]"
                                                                                placeholder="ex : 95857412"
                                                                                :value="item"></v-text-field>
                                                                    </v-col>


                                                                    <v-col v-if="index===0" cols="2" sm="1" md="1">
                                                                        <v-btn @click="add_test_number(2)" class="mx-2"
                                                                               fab dark small color="primary">
                                                                            <v-icon dark>mdi-plus</v-icon>
                                                                        </v-btn>
                                                                    </v-col>
                                                                    <v-col v-else cols="2" sm="1" md="1">
                                                                        <v-btn class="mx-2"
                                                                               @click="remove_test_number(index,2)" fab
                                                                               dark small
                                                                               color="red">
                                                                            <v-icon dark>mdi-minus</v-icon>
                                                                        </v-btn>
                                                                    </v-col>

                                                                </v-row>
                                                                <span style="color: #B71C1C"
                                                                      v-if="errors_test_number!=null">{{errors_test_number}}</span>

                                                            </v-col>

                                                            <v-col cols="12" sm="6" md="12">
                                                                <span class="col-12">{{$t('means_paiement.title_test_numbersucces')}}</span>
                                                                <v-row v-for="(item2, index2) in test_numbersuccesval"
                                                                       v-bind:key="index2"
                                                                       :id="index2+'row3'">
                                                                    <v-col cols="12" sm="10" md="10">
                                                                        <v-text-field
                                                                                type="number"
                                                                                @change="validestep(4)"
                                                                                clearable
                                                                                :label="$t('means_paiement.test_number')"
                                                                                name="succesvalues[]"
                                                                                placeholder="ex : 95857412"
                                                                                :value="item2"></v-text-field>
                                                                    </v-col>


                                                                    <v-col v-if="index2===0" cols="2" sm="1" md="1">
                                                                        <v-btn @click="add_test_number(3)" class="mx-2"
                                                                               fab dark small color="primary">
                                                                            <v-icon dark>mdi-plus</v-icon>
                                                                        </v-btn>
                                                                    </v-col>
                                                                    <v-col v-else cols="2" sm="1" md="1">
                                                                        <v-btn class="mx-2"
                                                                               @click="remove_test_number(index2,3)" fab
                                                                               dark small
                                                                               color="red">
                                                                            <v-icon dark>mdi-minus</v-icon>
                                                                        </v-btn>
                                                                    </v-col>

                                                                </v-row>
                                                                <span style="color: #B71C1C"
                                                                      v-if="errors_test_numbersucces!=null">{{errors_test_numbersucces}}</span>

                                                            </v-col>


                                                        </v-row>


                                                        <div class="text-right container">


                                                            <div class="offset-md-7 col-md-5">
                                                                <div class="row">
                                                                    <div class="col-md-6" style="padding: 2px">
                                                                        <v-btn
                                                                                class=" dark"
                                                                                text @click="e1 = 2">{{$t('return')}}
                                                                        </v-btn>

                                                                    </div>
                                                                    <div class="col-md-6" style="padding: 2px">
                                                                        <v-btn


                                                                                color="primary"
                                                                                @click.prevent="save"
                                                                                :disabled="!step4"
                                                                        >
                                                                            {{$t('save')}}

                                                                        </v-btn>
                                                                    </div>


                                                                </div>
                                                            </div>

                                                        </div>
                                                    </v-stepper-content>
                                                </v-stepper-items>
                                            </v-stepper>


                                        </v-form>
                                    </v-card-text>

                                </v-card>
                            </v-dialog>
                            <v-dialog v-model="dialogDetail" max-width="600px" v-if="selectedItem">

                                <v-card>
                                    <v-card-title>
                                        <v-col md="11" lg="11" sm="11">
                                            <span class="headline">  {{$t('usermeans.detailinfo')}} </span>
                                        </v-col>
                                        <v-col md="1" lg="1" sm="1">
                                            <v-icon style="cursor: pointer" @click="dialogDetail=false"> mdi-close
                                            </v-icon>
                                        </v-col>
                                    </v-card-title>
                                    <v-card-text>
                                        <table style="width: 100%" class="p-3 table table-striped">
                                            <tbody>


                                            <tr style="padding: 15px">
                                                <td style="padding: 15px"> {{$t("means_paiement.title")}}:</td>
                                                <td>
                                                    <div class="row">
                                                        <div class="col-md-3">
                                                            <a v-if="selectedItem._file"
                                                               href="javascript:void(0)"
                                                            >
                                                                <v-img
                                                                        :lazy-src="selectedItem._file"
                                                                        max-height="50"
                                                                        max-width="70"
                                                                        :src="selectedItem._file"
                                                                ></v-img>
                                                            </a>
                                                        </div>
                                                        <div class="col-md-8">
                                                            <div class="mt-2">{{selectedItem._name}}</div>
                                                        </div>

                                                    </div>


                                                </td>
                                            </tr>
                                            <tr style="padding: 15px">
                                                <td style="padding: 15px"> {{$t("usermeans.typeUsermeans")}}:</td>
                                                <td>{{selectedItem._type}}</td>
                                            </tr>
                                               <tr style="padding: 15px">
                                                <td style="padding: 15px"> {{$t("means_paiement.tbpays")}}:</td>
                                                <td>
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <div v-bind="attrs"
                                                                 v-on="on">
                                                                <country-flag :country=" selectedItem._country._code " size='normal'/>
                                                            </div>
                                                        </template>
                                                        <span>{{selectedItem._country._name}}</span>
                                                    </v-tooltip>
                                                </td>
                                            </tr>
                                            <tr style="padding: 15px">
                                                <td style="padding: 15px"> {{$t("means_paiement.tbtauxservice")}}:</td>
                                                <td>{{selectedItem._taux_service}} %</td>
                                            </tr>
                                            <tr style="padding: 15px">
                                                <td style="padding: 15px"> {{$t("means_paiement.taux_intram")}}:</td>
                                                <td>{{selectedItem._taux_intram}} %</td>
                                            </tr>

                                            <tr style="padding: 15px">
                                                <td style="padding: 15px"> {{$t("means_paiement.taux")}}:</td>
                                                <td>{{selectedItem._taux}} %</td>
                                            </tr>


                                            <tr style="padding: 15px">
                                                <td style="padding: 15px"> {{$t("means_paiement.fees_reversement")}}:</td>
                                                <td>{{selectedItem._fees_reversement}} {{(devisedatas?devisedatas._code_alpha:'---')}} </td>
                                            </tr>



                                            <tr style="padding: 15px">
                                                <td style="padding: 15px"> {{$t('means_paiement.title_prefixe')}}:</td>
                                                <td>
                                                    <div class="container">

                                                        <div class="" v-if="selectedItem._prefixes>0">
                                                            <v-chip v-for="row in selectedItem._prefixes" :key="row" style="margin-right: 1%"
                                                                    color="primary" dark>{{ row }}
                                                            </v-chip>
                                                        </div>
                                                        <div class="" v-else>
                                                            {{$t("means_paiement.liste_vide")}}
                                                        </div>
                                                    </div>

                                                </td>
                                            </tr>



                                            <tr style="padding: 15px">
                                                <td style="padding: 15px"> {{$t('means_paiement.title_test_numbersucces')}}:</td>
                                                <td>
                                                    <div class="container">

                                                        <div class="row" v-if="selectedItem._sandbox_numbers.success">
                                                            <v-chip v-for="row in selectedItem._sandbox_numbers.success" :key="row"
                                                                    style="margin-right: 1%" color="primary" dark>{{ row }}
                                                            </v-chip>
                                                        </div>
                                                        <div class="" v-else>
                                                            {{$t("means_paiement.liste_vide")}}
                                                        </div>
                                                    </div>

                                                </td>
                                            </tr>


                                            <tr style="padding: 15px">
                                                <td style="padding: 15px"> {{$t('means_paiement.title_test_number')}}:</td>
                                                <td>


                                                    <div class="container">
                                                        <div class="row" v-if="selectedItem._sandbox_numbers.error">
                                                            <v-chip v-for="row in selectedItem._sandbox_numbers.error" :key="row"
                                                                    style="margin-right: 1%" color="primary" dark>{{ row }}
                                                            </v-chip>
                                                        </div>
                                                        <div class="" v-else>
                                                            {{$t("means_paiement.liste_vide")}}
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>


                                            </tbody>
                                        </table>
                                    </v-card-text>

                                </v-card>
                            </v-dialog>
                        </v-toolbar>

                    </template>
                    <template v-slot:item.actions="{ item }">
                        <div style="text-align:  right">
                            <v-menu
                                    key="text"
                                    rounded="b-xl">
                                <template v-slot:activator="{ attrs, on }">

                                    <v-icon

                                            class="black--text "
                                            v-bind="attrs"
                                            v-on="on">mdi-dots-vertical
                                    </v-icon>

                                </template>
                                <v-list>
                                    <v-list-item
                                            v-for="(action_item, index) in actions_rows"
                                            :key="index"
                                            link
                                            @click="editRowAction(item,index)">
                                        <v-list-item-icon>
                                            <v-icon color="#29B3A6">
                                                {{index==1?(item._active?'mdi-cancel':action_item.avatar):action_item.avatar}}
                                            </v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title
                                                    v-text="index==1?(item._active?$t('means_paiement.desactivebtn'):$t('means_paiement.activebtn')):action_item.title"></v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </div>
                    </template>
                    <template v-slot:no-data>
                        {{$t('no_data')}}
                    </template>
                </v-data-table>
            </v-card>
        </div>


        <customsnackbar :snackbar="customSnack.snackbar"
                        :text="customSnack.text"
                        :snackcolor="customSnack.snackcolor" :snackbBtnColor="customSnack.snackbBtnColor"
                        :snacktimeout="customSnack.snacktimeout"></customsnackbar>

    </div>

</template>

<script>
    /* eslint-disable */
    import {mapState} from "vuex";
    import * as Swal from "sweetalert2";
    import CountryFlag from 'vue-country-flag'
    import VueClipboard from 'vue-clipboard2'
    import helpers from "../../mixins/helpers";

    VueClipboard.config.autoSetContainer = true;


    export default {
        components: {
            CountryFlag, VueClipboard

        },
        mixins: [helpers(this)],
        label: "means_paiement",
        data() {
            return {
                submitting: false,
                valid: true,
                dialogDetail: false,
                selectedItem: undefined,
                customSnack: {
                    snackbar: false,
                    text: "",
                    snackcolor: "black",
                    snackbBtnColor: "white",
                    snacktimeout: 2000
                },
                lazy: false,
                errors: undefined,
                errors_file: null,
                errors_name: null,
                errors_prefix: null,
                errors_test_number: null,
                errors_test_numbersucces: null,
                errors_fees: null,
                dialogShowImg: false,
                link: "",
                nametheme: '',
                search: '',
                dialog: false,
                step1: false,
                step2: false,
                step3: false,
                step4: true,
                type: 'Mobile',
                e1: 1,
                prefixeval: [""],
                test_numberval: [""],
                test_numbersuccesval: [""],
                typesLists: ['Mobile', 'Banque'],
                id: undefined,
                actions_items: [
                    {title: this.$t('means_paiement.new')},
                    {title: this.$t('means_paiement.confirm')}
                ],
                headers: [
                    {text: this.$t('means_paiement.tbimg'), value: '_file', sortable: true},
                    {text: this.$t('means_paiement.tbmoyen'), value: '_name', sortable: true},
                    {
                        text: this.$t('means_paiement.tbtype'),
                        align: 'start',
                        sortable: true,
                        value: '_type',
                    },
                    {text: this.$t('means_paiement.tbcode'), value: '_code', sortable: true},

                    /*{text: this.$t('means_paiement.tbtaux'), value: '_taux', sortable: true},
                    {text: this.$t('means_paiement.tbtauxintram'), value: '_taux_intram', sortable: true},
                    {text: this.$t('means_paiement.tbtauxservice'), value: '_taux_service', sortable: true},
                    {text: this.$t('means_paiement.tbprefixes'), value: '_prefixes', sortable: true},
                    {text: this.$t('means_paiement.tbtext_numbers'), value: '_sandbox_numbers', sortable: true},*/
                    {text: this.$t('means_paiement.tbpays'), value: '_country._name'},
                    {text: this.$t('means_paiement.tbetat'), value: '_active'},
                    {text: this.$t('means_paiement.tbactions'), value: 'actions', sortable: false},
                ],
                editedIndex: -1,
                editedOldImg: "",
                devisedatas: undefined,
                editedItem: {
                    _type: '',
                    _name: '',
                    _file: '',
                    _country: '',
                    _id: 0,
                    _created_at: 0,
                    _taux: 1,
                    _taux_service: 1,
                    _taux_intram: 1,
                    _fees_reversement: 0,
                    _prefixes: [],
                },
                defaultItem: {
                    _type: '',
                    _name: '',
                    _file: '',
                    _country: '',
                    _id: 0,
                    _created_at: 0,
                    _taux: 1,
                    _taux_service: 1,
                    _taux_intram: 1,
                    _fees_reversement: 0,
                    _prefixes: [],

                },
                typeRules: [
                    v => !!v || 'Type requis',
                    // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                ],
                countryRules: [
                    v => !!v || 'Pays requis',
                ],
                codeRules: [
                    v => !!v || 'Logo / Image requis',
                ],
                nameRules: [
                    v => !!v || 'Nom requis',
                ],
                fees_reversementRules: [
                    v => !!v || 'Frais requis',
                ],
                actions_rows: [
                    {title: this.$t('means_paiement.detail'), avatar: 'mdi-information-variant'},
                    {title: this.$t('means_paiement.desactivebtn'), avatar: 'mdi-alarm-light-outline'},
                    {title: this.$t('updatebtn'), avatar: 'mdi-pencil'},
                    {title: this.$t('deletebtn'), avatar: 'mdi-delete'}
                ],

            }
        }
        ,
        computed: {
            formTitle() {
                return this.editedIndex === -1 ? this.$t('means_paiement.new') : this.$t('means_paiement.update')
            }
            ,
            ...mapState('means_paiements/', ['means_paiements'])
            ,
            ...mapState('countries/', ['countries']),
            ...mapState('devises/', ['devise']),

        }
        ,
        mounted() {

            this.$store.dispatch('means_paiements/getMeans_paiements').then(response => {
                window.console.log('means_paiements', response)
            });
            this.$store.dispatch('countries/getCountries').then(response => {
                console.log('countries', response);
            });

            this.$store.dispatch('generalsettings/getGeneralSetting').then(response => {
                console.log('getGeneralSetting', response)
                let data3 = new FormData();
                data3.append("id", response.generalsettings.dda);
                this.$store.dispatch('devises/getById', data3).then(response => {
                    window.console.log('devises', response)
                    this.devisedatas = response.data.devise;
                });
            });
        }
        ,
        watch: {
            dialog(val) {

                val || this.close()
            },
        }
        ,
        methods: {
            initialize() {

            },
            showImage(img, name, type) {

                this.type = type;
                this.link = img;
                this.nametheme = name;
                this.dialogShowImg = true;
            },
            editRowAction(item, index) {
                switch (index) {
                    case 0:
                        this.dialogDetail = true;
                        this.selectedItem = item;
                        break;
                    case 1:
                        this.editItemState(item)
                        break;
                    case 2:
                        this.editItem(item)
                        break;
                    case 3:
                        this.deleteItem(item)
                        break;
                }
            },
            onCopy: function (e) {

                this.customSnack.snackbBtnColor = "#29B3A6";
                this.customSnack.snackcolor = "#000";
                this.customSnack.snacktimeout = 2000;
                this.customSnack.text = this.$t("copie") + e.text;
                this.customSnack.snackbar = true;
            },
            onError: function (e) {
                this.text = this.$t("copiefailed");
                this.snackbar = true;
            },
            setdefault() {
                this.e1 = 1;
                this.prefixeval = [22965];
                this.test_numberval = ["95000000"];
                this.test_numbersuccesval = ["95000001"];
                this.step1 = false;
                this.step2 = false;
                this.step3 = false;
                this.step4 = true;
                $(".chooseAll").css("background-color", "");
            }
            ,
            setdefaultClose() {
                this.e1 = 1;
                this.prefixeval = [22965];
                this.test_numberval = ["95000000"];
                this.test_numbersuccesval = ["95000000"];
                this.step1 = false;
                this.step2 = false;
                this.step3 = false;
                this.step4 = true;
                $(".chooseAll").css("background-color", "");
                this.dialog = false;
            }

            ,
            editItemAction(index) {

                switch (index) {
                    case 0:
                        this.dialog = true;
                        break;
                    case 1:
                        this.$router.push({name: "usersmeanspaiementconfirmation"});

                        break;
                }

            },
            chooseItem(item) {
                this.step1 = false;
                this.editedItem._type = item;
                /*$(".chooseAll").css("background-color", "");
                $("#" + item).css("background-color", "#A1C4E8");*/
                this.validestep(1)

            },
            getBackColor(type) {
                if (type == this.editedItem._type) {
                    return "background-color: rgb(0 181 164 / 16%)!important;";
                } else {
                    return "";
                }
            },
            validestep(step) {

                switch (step) {
                    case 1:
                        if (this.typesLists.includes(this.editedItem._type) && this.editedItem._country !== '') {
                            this.step1 = true;
                        } else {
                            this.step1 = false;
                        }
                        break;

                    case 2:

                        this.selectedFile()

                        break;
                    case 3:
                        this.errors_fees = null;

                        this.step3 = true;

                        if (this.editedItem._fees_reversement != '') {
                            if (isNaN(this.editedItem._fees_reversement)) {
                                this.step3 = false;
                                this.errors_fees = this.$t('means_paiement.error_frees');
                            } else {
                                this.step3 = true;
                            }
                        } else {
                            this.step3 = false;
                            this.errors_fees = this.$t('means_paiement.error_frees');
                        }

                        break;

                    case 4:
                        this.errors_prefix = null;
                        this.errors_test_number = null;
                        this.errors_fees = null;

                        this.step4 = true;
                        let tab_prefixe = [];
                        let tab_test_number = [];

                        let i = 0;
                        $('input[name^="prefixe"]').each(function () {
                            if (!isNaN(parseInt($(this).val()))) {
                                tab_prefixe[i] = parseInt($(this).val());
                                i++;
                            }
                        });

                        if (tab_prefixe.length == 0) {
                            tab_prefixe[0] = 22965;
                        }

                        this.prefixeval = [];
                        this.prefixeval = tab_prefixe;
                        console.log("this.prefixeval", this.prefixeval);

                        let j = 0;
                        $('input[name^="test_number"]').each(function () {
                            if (!isNaN(parseInt($(this).val()))) {
                                tab_test_number[j] = parseInt($(this).val());
                                j++;
                            }
                        });

                        if (tab_test_number.length == 0) {
                            tab_test_number[0] = 95000000;
                        }

                        this.test_numberval = [];
                        this.test_numberval = tab_test_number;
                        console.log("this.tab_test_number", this.test_numberval);

                        if (this.test_numberval.length === 0) {
                            this.step4 = false;
                            this.errors_test_number = this.$t('devises.errors_test_number');
                        } else {
                            if (this.editedItem._type === "Mobile") {
                                if (this.prefixeval.length === 0) {
                                    this.step4 = false;
                                    this.errors_prefix = this.$t('devises.errors_prefixe');
                                } else {
                                    this.step4 = true;
                                }
                            } else {
                                this.step4 = true;
                            }
                        }


                        break;

                }

            }
            ,
            selectedFile() {
                this.errors_file = null;
                this.errors_name = null;
                let fileName = $("#input_file").val();

                let regex = new RegExp('[^.]+$');

                let extension = fileName.match(regex);

                let tab_ext = ["jpg", "jpeg", "png"];
                var letterNumber = /^[-\w\s]+$/;
                if (fileName.length !== 0) {
                    if (tab_ext.includes(extension[0])) {
                        if (this.editedItem._name.match(letterNumber)) {
                            this.step2 = true;
                        } else {
                            this.errors_name = this.$t('devises.errors_name');
                            this.step2 = false;
                        }
                    } else {
                        this.errors_file = this.$t('devises.errors_file');
                        this.step2 = false;
                    }
                } else {
                    if (this.editedIndex > -1) {
                        if (this.editedItem._name.match(letterNumber)) {
                            this.step2 = true;
                        } else {
                            this.errors_name = this.$t('devises.errors_name');
                            this.step2 = false;
                        }

                    } else {
                        this.errors_file = this.$t('devises.errors_file');
                        this.step2 = false;
                    }

                }


            },
            add_cqq() {
                let tab_prefixe = [];

                let i = 0;
                $('input[name^="prefixe"]').each(function () {
                    if (!isNaN(parseInt($(this).val()))) {
                        tab_prefixe[i] = parseInt($(this).val());
                        i++;
                    }

                });
                tab_prefixe[i] = 22961;

                this.prefixeval = [];
                this.prefixeval = tab_prefixe;

            },
            add_test_number(pos) {
                let tab_test_number = [];
                let champ = "test_number";
                switch (pos) {
                    case 2:
                        champ = "test_number"
                        break;

                    case 3:
                        champ = "succesvalues"
                        break;


                }


                let i = 0;
                $('input[name^="' + champ + '"]').each(function () {
                    if (!isNaN(parseInt($(this).val()))) {
                        tab_test_number[i] = parseInt($(this).val());
                        i++;
                    }

                });

                tab_test_number[i] = "95000000";
                switch (pos) {
                    case 2:
                        this.test_numberval = [];
                        this.test_numberval = tab_test_number;
                        break;

                    case 3:
                        this.test_numbersuccesval = [];
                        this.test_numbersuccesval = tab_test_number;
                        break;


                }
            },
            remove_cqq(index) {
                let tab_prefixe = [];

                $("#" + index + 'row').remove();

                let i = 0;
                $('input[name^="prefixe"]').each(function () {
                    if (!isNaN(parseInt($(this).val()))) {
                        tab_prefixe[i] = parseInt($(this).val());
                        i++;
                    }
                });
                if (tab_prefixe.length == 0) {
                    tab_prefixe[0] = 22965;
                }


                this.prefixeval = [];
                this.prefixeval = tab_prefixe;
            }
            ,
            remove_test_number(index, pos) {
                let tab_test_number = [];
                let champ = "test_number";
                switch (pos) {
                    case 2:
                        champ = "test_number"
                        break;

                    case 3:
                        champ = "succesvalues"
                        break;


                }
                $("#" + index + 'row' + pos).remove();

                let i = 0;
                $('input[name^="' + champ + '"]').each(function () {
                    if (!isNaN(parseInt($(this).val()))) {
                        tab_test_number[i] = parseInt($(this).val());
                        i++;
                    }
                });
                if (tab_test_number.length == 0) {
                    tab_test_number[0] = 95000000;
                }


                switch (pos) {
                    case 2:
                        this.test_numberval = [];
                        this.test_numberval = tab_test_number;
                        break;

                    case 3:
                        this.test_numbersuccesval = [];
                        this.test_numbersuccesval = tab_test_number;
                        break;
                }
            }
            ,
            editItemState(item) {
                this.customSnack.snackbar = false;
                const index = this.means_paiements.indexOf(item);
                Swal.fire({
                    icon: 'warning',
                    timerProgressBar: false,
                    text: item._active ? this.$t('means_paiement.textDesactived') : this.$t('means_paiement.textActived'),
                    confirmButtonText: item._active ? this.$t('means_paiement.desactivebtn') : this.$t('means_paiement.activebtn'),
                    cancelButtonText: this.$t('cancel'),
                    cancelButtonColor: "#CCC",
                    confirmButtonColor: "#29B3A6",
                    showCancelButton: true
                }).then(result => {
                    if (result.value) {
                        let data = new FormData();
                        data.append("id", item._id);
                        data.append("newstate", item._active ? false : true);
                        this.$store.dispatch('means_paiements/changeStateMeans_paiement', data).then((response) => {
                            this.showSnackDefault(response);

                        })
                    }
                })
            },
            editItem(item) {
                console.log(item._sandbox_numbers ? item._sandbox_numbers.error : ["95000000"]);
                this.step1 = true;
                this.step2 = true;
                this.step3 = true;
                this.step4 = true;
                this.errors_file = null;
                $(".chooseAll").css("background-color", "");
                this.editedIndex = this.means_paiements.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.editedItem._country = item._country._id;
                this.editedItem._taux = item._taux;
                this.prefixeval = item._prefixes;
                this.test_numberval = item._sandbox_numbers ? item._sandbox_numbers.error : ["95000000"];
                this.test_numbersuccesval = item._sandbox_numbers ? item._sandbox_numbers.success : ["95000000"];
                this.editedOldImg = item._file;
                $("#countries option").each(function () {
                    if ($(this).val() == item._country._id) {
                        $(this).attr("selected", "selected");
                    }
                });
                if (this.editedItem._type == "Mobile") {
                    $("#Mobile").css("background-color", "#A1C4E8");

                } else {
                    $("#Banque").css("background-color", "#A1C4E8");
                }
                this.dialog = true;
            }
            , deleteItem(item) {

                const index = this.means_paiements.indexOf(item);
                Swal.fire({
                    icon: 'warning',
                    timerProgressBar: false,
                    text: this.$t('delete_warning'),
                    confirmButtonText: this.$t('delete'),
                    cancelButtonText: "Annuler",
                    cancelButtonColor: "#CCC",
                    confirmButtonColor: "#29B3A6",
                    showCancelButton: true
                }).then(result => {
                    if (result.value) {
                        this.$store.dispatch('means_paiements/deleteMeans_paiement', item._id).then((response) => {
                            this.showSnackDefault(response);
                        })
                    }
                })
            },
            close() {
                this.dialog = false;
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1
                });
                this.$refs.form.reset()
            },
            save() {
                this.customSnack.snackbar = false;

                this.submitting = true;
                this.step3 = false;
                let VueBox = this;

                this.prefixeval = this.getArrayNameInput("prefixe");
                this.test_numberval = this.getArrayNameInput("test_number");
                this.test_numbersuccesval = this.getArrayNameInput("succesvalues");


                this.editedItem._prefixes = this.prefixeval;
                this.editedItem._sandbox_numbers = {"success": this.test_numbersuccesval, "error": this.test_numberval};
                this.editedItem._taux = this.editedItem._taux_intram + this.editedItem._taux_service;
                let data = new FormData();
                data.append("type", this.editedItem._type);
                data.append("name", this.editedItem._name);
                data.append("file", this.editedItem._file);
                data.append("country_id", this.editedItem._country);
                data.append("taux", this.editedItem._taux);
                data.append("taux_service", this.editedItem._taux_service);
                data.append("taux_intram", this.editedItem._taux_intram);
                data.append("fees_reversement", this.editedItem._fees_reversement);
                data.append("prefixe", JSON.stringify(this.editedItem._prefixes));
                data.append("sandbox_numbers", JSON.stringify(this.editedItem._sandbox_numbers));
                let mineroute = 'means_paiements/setMeans_paiement';
                if (this.editedIndex > -1) {
                    data.append("id", this.editedItem._id);
                    data.append("oldFile", this.editedOldImg);
                    mineroute = 'means_paiements/setUpdateMeans_paiement';
                }


                this.$store.dispatch(mineroute, data).then((response) => {
                    this.submitting = false;
                    VueBox.$parent.resetDatas(VueBox);
                    this.close();

                    if (response.data.error) {
                        this.toast('error',response.data.message)
                    } else {

                        this.toast('success',response.data.message)
                        this.closeexcel();
                    }
                })
            },
            validate() {
                this.$refs.form.validate()
            },
            reset() {
                this.$refs.form.reset()
            },
            checkisDashboard() {
                this.$emit('checkisDashboard', true);
            },
            fileChange() {
                console.log(this.$refs);
                this.editedItem._file = this.$refs.file.files[0];
            },
            getFileOriginalName(file) {
                return file.substr(file.lastIndexOf('/') + 1)
            },
            checkIfExist() {
                let VueBox = this;
                if (VueBox.editedIndex > -1) {
                    return VueBox.countries.find(value => value._code === VueBox.editedItem.code && value._id !== VueBox.editedItem._id)
                } else {
                    return VueBox.countries.find(value => value._code === VueBox.editedItem.code)
                }
            },
            getColor(calories) {
                if (calories == "Banque") return 'green'
                else if (calories == "Mobile") return 'orange'
                else return 'green'
            },
            getArrayNameInput(champ) {
                let tab_test_number = [];
                let i = 0;
                $('input[name^="' + champ + '"]').each(function () {
                    if (!isNaN(parseInt($(this).val()))) {
                        tab_test_number[i] = parseInt($(this).val());
                        i++;
                    }

                });
                return tab_test_number;
            }
        }
        ,
        created() {
            this.checkisDashboard();
            this.initialize()
        }
    }
</script>

<style scoped>

    .name_country_tab {
        margin-top: 3.3%;
        font-weight: bold;
    }

</style>
